// Action Types
export const LIST_REQUEST = 'DOCUMENTS/LIST_REQUEST'
export const LIST_RESPONSE = 'DOCUMENTS/LIST_RESPONSE'
export const LIST_DONE = 'DOCUMENTS/LIST_DONE'
export const GROUPS_RESPONSE = 'DOCUMENTS/GROUPS_RESPONSE'
